import React, { useEffect, useState } from "react";

import { Row, Modal, Col, Card, Table, Button, Typography, Input, Select, Tag, Switch } from "antd";

import { SearchOutlined, FileOutlined } from "@ant-design/icons";

import { columnsExpedienteVirtualUsuario } from "../helpers/columnsExpedienteVirtualDocumentos";

import { ObtenerJuzgados } from "../actions/juzgadoActions";
import { ObtenerMateria } from "../actions/materiaAction";
import { ObtenerDistritoJudicial } from "../actions/distritoJudicialActions";
import { HabilitarDocumentoUsuario, ObtenerDocumentosExpedienteVirtualUsuario } from "../actions/expedienteActions";

const { Title, Text } = Typography;

export const VisualizarDocumentos = () => {

    const [isModalDocumentoVisible, setIsModalDocumentoVisible] = useState( false );
   
    const [data, setData] = useState( [] );
    
    const [documento, setDocumento] = useState( '' );
    const [loading, setLoading] = useState( false );

    const [juzgado, setJuzgado] = useState( 0 );
    const [juzgadosArray, setJuzgadosArray] = useState( [] );
    
    const [materia, setMateria] = useState( 0 );
    const [materiaArray, setMateriaArray] = useState( [] );
    
    const [distritoJudicial, setDistritoJudicial] = useState( 0 );
    const [distritoJudicialArray, setDistritoJudicialArray] = useState( [] );
    
    const [numeroExpediente, setNumeroExpediente] = useState( '' );

    const handleBuscar = async () => {

        setLoading(true);
        setData( [] );

        await ObtenerDocumentosExpedienteVirtualUsuario({ numeroExpediente, idJuzgado: juzgado }).then(response => {

            if ( response ) {

                if ( response.status === 200 ) {

                    if ( response.data ) {

                        setTimeout(() => {                         
                            
                            var data = response?.data?.map( ( elem ) => {

                                let estatus = <Text></Text>

                                if( elem.idEstatus === 1 ){
                                    estatus = <Switch checked={ elem.idEstatus === 1 } onChange={ (e) => handleChangeSwitch( elem.idDocumento, e, response?.data ?? [] ) } />;
                                }
                                else if( elem.idEstatus === 2 ){
                                    estatus = <Switch checked={ elem.idEstatus === 1 } onChange={ (e) => handleChangeSwitch( elem.idDocumento, e, response?.data ?? [] ) } />;
                                }
                                else if( elem.estatus === 'Archivado' ){
                                    estatus = <Tag color={"gold"} style={{ padding: 3, textAlign: 'center', borderRadius: 50 }}>{elem.estatus}</Tag>
                                }

                                return {

                                    key: elem.idDocumento,
                                    documento: <Title level={5}>{elem.nombreDocumento}</Title>,
                                    tipo: <Title level={5}>{elem.tipoDocumento}</Title>,
                                    extension: <Title level={5}>{elem.extension}</Title>,
                                    fecha: <Title level={5}>{elem.fecha}	</Title>,
                                    estatus: estatus,
                                    actions: 
                                        elem.extension === '.odt'
                                            ?
                                                <Button href={ elem.enlaceDocumento } type="link"> 
                                                    <FileOutlined style={{ fontSize: '20px' }} /> 
                                                </Button>
                                            :
                                                <Button onClick={() => handleVerDocumento( elem.enlaceDocumento, elem.extension )} type="link"> 
                                                    <FileOutlined style={{ fontSize: '20px' }} /> 
                                                </Button>
                                }
                            })
                               
                            setLoading( false );
                            setData( data );

                        }, 700);

                    }

                }

            }

        });
    }

    const handleVerDocumento = ( doc ) => {
       
        setDocumento( doc ); 
        
        setIsModalDocumentoVisible( true );

    }

    const handleChangeSwitch = async ( id, value, datos ) => {

        await HabilitarDocumentoUsuario({ idDocumento: id, value }).then( resp => {

            if( resp ){

                const { success } = resp.data;

                if( success ){

                    const newArray = datos.map( ( elem ) => {

                        if( elem.idDocumento === id ){
                            elem.idEstatus = value ? 1 : 2;
                        }
            
                        return elem;
                    });
            
                    setData( newArray.map( ( elem ) => {
            
                        let estatus = <Text></Text>
            
                        if( elem.idEstatus === 1 ){
                            estatus = <Switch checked={ elem.idEstatus === 1 } onChange={ (e) => handleChangeSwitch( elem.idDocumento, e, datos ) } />;
                        }
                        else if( elem.idEstatus === 2 ){
                            estatus = <Switch checked={ elem.idEstatus === 1 } onChange={ (e) => handleChangeSwitch( elem.idDocumento, e, datos ) } />;
                        }
                        else if( elem.estatus === 'Archivado' ){
                            estatus = <Tag color={"gold"} style={{ padding: 3, textAlign: 'center', borderRadius: 50 }}>{elem.estatus}</Tag>
                        }
            
                        return {
            
                            key: elem.idDocumento,
                            documento: <Title level={5}>{elem.nombreDocumento}</Title>,
                            tipo: <Title level={5}>{elem.tipoDocumento}</Title>,
                            extension: <Title level={5}>{elem.extension}</Title>,
                            fecha: <Title level={5}>{elem.fecha}	</Title>,
                            estatus: estatus,
                            actions: 
                                elem.extension === '.odt'
                                    ?
                                        <Button href={ elem.enlaceDocumento } type="link"> 
                                            <FileOutlined style={{ fontSize: '20px' }} /> 
                                        </Button>
                                    :
                                        <Button onClick={() => handleVerDocumento( elem.enlaceDocumento, elem.extension )} type="link"> 
                                            <FileOutlined style={{ fontSize: '20px' }} /> 
                                        </Button>
                        }
                    }) );

                }

            }

        });
       
    }

    useEffect(() => {

        async function Obtener() {

            await ObtenerDistritoJudicial().then( response => {
   
                if ( response ) {

                    if ( response.status === 200 ) {

                        if ( response.data ){
                            setDistritoJudicialArray( response.data );
                        }

                    }

                }

            });

        }

        Obtener();

    }, [])
    
    useEffect(() => {

        async function Obtener() {

            await ObtenerMateria().then( response => {

                if ( response ) {

                    if ( response.status === 200) {

                        if ( response.data ) {
                            setMateriaArray( response.data );
                        }

                    }

                }

            });

        }

        Obtener();

    }, [])
    
    useEffect(() => {

        async function Obtener() {

            if( materia !== 0 ){

                const params ={
                    idMateria: materia,
                    idDistritoJudicial: distritoJudicial
                }

                await ObtenerJuzgados( params ).then(response => {
    
                    if ( response ) {
    
                        if ( response.status === 200 ) {
    
                            if ( response.data ) {
                                setJuzgadosArray( response.data );
                            }
    
                        }
    
                    }
    
                });
            }

        }

        if( materia !== 0 && distritoJudicial !== 0 ){
            Obtener();
        }

    }, [ materia, distritoJudicial ])

    return (
        <>

            <div className="tabled">

                <Row gutter={[24, 0]}>

                    <Col xs="24" xl={24} >

                        <Card
                            bordered={false}
                            className="criclebox tablespace mb-24"
                            style={{ width: '100%', padding: '1em' }}
                        >

                            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify='end'>

                                <Col className="gutter-row" span={6}>
                                    <Input placeholder="1/2022" value={numeroExpediente} onChange={(e) => { setNumeroExpediente(e.target.value)}}/>
                                </Col>

                                <Col className="gutter-row" span={6}>
                                    <Select size="large" style={{ width: '100%' }} value={distritoJudicial} onChange={(e) => { setDistritoJudicial(e)}}>
                                        <Select.Option value={0}>Seleccione una opción</Select.Option>
                                        {
                                            distritoJudicialArray.map((element) => (
                                                <Select.Option key={element.idDistritoJudicial} value={element.idDistritoJudicial}>{element.descripcion}</Select.Option>
                                                
                                            ))
                                        }
                                    </Select>
                                </Col>

                                <Col className="gutter-row" span={6}>
                                    <Select size="large" style={{ width: '100%' }} value={materia} onChange={(e) => {setMateria(e) }} disabled={ distritoJudicial === 0 } >
                                        <Select.Option value={0}>Seleccione una opción</Select.Option>
                                        {
                                            materiaArray.map((element) => (
                                                <Select.Option key={element.idMateria} value={element.idMateria}>{element.descripcion}</Select.Option>
                                                
                                            ))
                                        }
                                    </Select>
                                </Col>

                                <Col className="gutter-row" span={6}>
                                    <Select size="large" style={{ width: '100%' }} value={juzgado} onChange={(e) => {setJuzgado(e) }} disabled={ ( materia === 0 && distritoJudicial === 0 ) } >
                                        <Select.Option value={0}>Seleccione una opción</Select.Option>
                                    {
                                            juzgadosArray.map((element) => (
                                                <Select.Option key={element.idJuzgado} value={element.idJuzgado }>{element.descripcion}</Select.Option>
                                                
                                            ))
                                        }
                                    </Select>
                                </Col>

                                <Col className="gutter-row" span={6}  >
                                    <Button style={{ fontSize: '14px', width: '100%', marginTop: '1em' }} icon={ <SearchOutlined /> } onClick={ () => handleBuscar() } disabled={ ( numeroExpediente === "" || juzgado === 0 ) } loading={ loading }>
                                        Buscar
                                    </Button>
                                </Col>
                                
                            </Row>

                        </Card>
                                
                        <Card
                            bordered={false}
                            className="criclebox tablespace mb-24"
                            style={{ width: '100%' }}
                        >
                            <div className="table-responsive">

                                <Table
                                    className="ant-border-space"
                                    columns={ columnsExpedienteVirtualUsuario }
                                    dataSource={ data }
                                    loading={ loading }
                                    pagination={ true }

                                />

                            </div>

                            <Row gutter={[24, 0]} style={{ padding: '1em' }} >

                                <Col span={12} style={{ textAlign: 'left' }}>
                                    <Title level={5}>Total de documentos: { data.length }</Title>
                                </Col>

                            </Row>

                        </Card>

                    </Col>

                </Row>

            </div>

            <Modal
                title="Documento"
                open={isModalDocumentoVisible}
                maskClosable={false}
                centered
                footer={null}
                onCancel={() => { setIsModalDocumentoVisible(false); }}
                width={800}
            >
                <iframe
                    title='iframe documento'
                    src={documento}
                    style={{ width: '100%', height: '500px' }}
                />
            </Modal>
            
        </>
    );

}
